import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOffersCphOsl,
  alternativeOffersOslCph,
  asyncAlternativeOfferConfirmationJobCompletedFor0E,
  asyncAlternativeOfferConfirmationJobInProgressFor0E,
  orderEligibilitiesMockEligibleFororderForMultiPaxRoundTrip,
  orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip,
  orderWithBothBoundsAcknowledged,
  orderWithBothBoundsDisrupted,
  orderWithReturnBoundDisrupted,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
} from '../../../mock/dictionaries';

export const multiDisruptedBoundsRebookingMock: MockMap = {
  retrieveOrder: [
    createMockData(orderWithBothBoundsDisrupted, [], [flightDisruptionWarning]),
    createMockData(orderWithReturnBoundDisrupted, [], [flightDisruptionWarning]),
    createMockData(orderWithBothBoundsAcknowledged)
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl), createMockData(alternativeOffersOslCph)],
  acknowledge: [createMockData({})],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(asyncAlternativeOfferConfirmationJobInProgressFor0E)],
  getAlternativeOfferConfirmationJob: [createMockData(asyncAlternativeOfferConfirmationJobCompletedFor0E)]
};

export const multiDisruptedBoundsRebookTogetherMock: MockMap = {
  retrieveOrder: [
    createMockData(orderWithBothBoundsDisrupted, [], [flightDisruptionWarning]),
    createMockData(orderWithBothBoundsAcknowledged)
  ],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip)],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl), createMockData(alternativeOffersOslCph)],
  acknowledge: [createMockData({})],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(asyncAlternativeOfferConfirmationJobInProgressFor0E)],
  getAlternativeOfferConfirmationJob: [createMockData(asyncAlternativeOfferConfirmationJobCompletedFor0E)]
};

export const multiDisruptedBoundsRebookTogetherRefundableMock: MockMap = {
  retrieveOrder: [
    createMockData(orderWithBothBoundsDisrupted, [], [flightDisruptionWarning]),
    createMockData(orderWithBothBoundsAcknowledged)
  ],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleFororderForMultiPaxRoundTrip)],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl), createMockData(alternativeOffersOslCph)],
  acknowledge: [createMockData({})],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(asyncAlternativeOfferConfirmationJobInProgressFor0E)],
  getAlternativeOfferConfirmationJob: [createMockData(asyncAlternativeOfferConfirmationJobCompletedFor0E)]
};
